// 字典
import request from '../request/request';
import {handleRes} from '../utils/utils';


interface HandleResInterface {
    success: any,
    fail: any,
}


const GETGetDict = (params: any): Promise<HandleResInterface> => {
    return new Promise(async (resolve) => {
        const res = await request.GETDictDictionaryAll(params);
      const handleParams = {}
      if(res.code !== 200 && res.code !== 401){
        // @ts-ignore
        handleParams.failMes = res.msg
      }
        const result = handleRes(res, handleParams);
        resolve(result);
    });
};


export {
	GETGetDict,
};
